import React from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function RedemptionInfoModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-70" />
       <div className="relative bg-gray-900 text-white rounded-xl p-6 sm:p-8 w-[90vw] max-w-sm text-center z-50 border-2 border-yellow-500 shadow-2xl">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-300 hover:text-white"
            aria-label="Close"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>

          <Dialog.Title className="text-xl font-bold text-yellow-400 mb-2">
            Redemption Spin 🎯
          </Dialog.Title>
          <Dialog.Description className="text-sm text-gray-300">
            When you lose twice in a row, we feel your pain. So we offer you a chance to redeem yourself — on the house.
            <br /><br />
            This special spin won't cost you anything, and you could win back some $REGRET, get a refund, or just… lose again.
            <br /><br />
            Remember: regret builds character. 💀
          </Dialog.Description>
        </div>
      </div>
    </Dialog>
  );
}
